<template>
  <div class="my-order">
    <div class="section-title">我的订单</div>

    <div class="order-tabs">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="全部订单(0)" name="all">
          <empty-component text="暂无订单信息"></empty-component>
        </el-tab-pane>
        <el-tab-pane label="待付款(0)" name="waitPay">
          <empty-component text="暂无待付款订单"></empty-component>
        </el-tab-pane>
        <el-tab-pane label="待发货(0)" name="waitDeliver">
          <empty-component text="暂无待发货订单"></empty-component>
        </el-tab-pane>
        <el-tab-pane label="待收货(0)" name="waitReceive">
          <empty-component text="暂无待收货订单"></empty-component>
        </el-tab-pane>
        <el-tab-pane label="待评价(0)" name="waitComment">
          <empty-component text="暂无待评价订单"></empty-component>
        </el-tab-pane>
        <el-tab-pane label="已完成(0)" name="finished">
          <empty-component text="暂无已完成订单"></empty-component>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import EmptyComponent from './EmptyComponent.vue'

export default {
  name: 'MyOrder',
  components: {
    EmptyComponent
  },
  data() {
    return {
      activeTab: 'all'
    }
  },
  created() {
    // 从路由参数获取初始 tab
    const { tab } = this.$route.query
    if (tab) {
      this.activeTab = tab
    }
  }
}
</script>

<style lang="scss" scoped>
.my-order {
  .section-title {
    font-size: 20px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
    text-align: left;
  }

  .order-tabs {
    background-color: #fff;
    border-radius: 4px;
    padding: 20px;

    :deep(.el-tabs__nav-wrap::after) {
      height: 1px;
    }

    :deep(.el-tabs__active-bar) {
      height: 2px;
    }
  }
}
</style>
